<template>
  <div class="hit-vs-miss">
    <Doughnut
      :values="missVsHitTargetData.values"
      :labels="missVsHitTargetData.labels"
      :colors="missVsHitTargetData.colors"
      :title="missVsHitTargetData.title"
      :semicircle="true"
    />
  </div>
</template>

<script>
import Doughnut from "./Charts/Doughnut";
import utils from "../../services/utils";
export default {
  props: ["targetHistories", "targetType"],
  components: { Doughnut },
  computed: {
    missVsHitTargetData() {
      const practiceDays = this.targetHistories.filter(th => !!th.target);
      const hitTargetCount = practiceDays.filter(th =>
        this.isTargetHit(th.target)
      ).length;
      const missedTargetCount = practiceDays.length - hitTargetCount;
      return {
        values: [hitTargetCount, missedTargetCount],
        labels: ["Hit Target", "Missed Target"],
        colors: [utils.colors.green, utils.colors.orange],
        title: this.getTitle()
      };
    }
  },
  methods: {
    isTargetHit(target) {
      switch (this.targetType) {
        case "recordings":
          return target.targetDailyRecordings <= target.currentDailyRecordings;
        case "seconds":
          return target.targetDailySeconds <= target.currentDailySeconds;
        case "spellings":
          return target.targetDailySpellings <= target.currentDailySpellings;
        default:
          break;
      }
    },
    getTitle() {
      switch (this.targetType) {
        case "recordings":
          return "Recordings";
        case "seconds":
          return "Seconds";
        case "spellings":
          return "Words";
        default:
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.hit-vs-miss {
  max-height: 350px;
  max-width: 350px;
}
</style>
